import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = { class: "justify-center" }
const _hoisted_6 = { class: "mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[40%]" }
const _hoisted_7 = { class: "w-3/4" }
const _hoisted_8 = {
  key: 0,
  class: "w-full mt-5"
}
const _hoisted_9 = { class: "flex justify-center mt-[1.5rem]" }

import { ref, onMounted } from 'vue';
import CustomButton from "@/components/forms/CustomButton.vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRoute } from "vue-router";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPageJackpot',
  setup(__props) {

const route = useRoute(); 

const product = ref({
    reductionValue: "",
    minPrice: "",
    maxPrice: "",
    productName: "",
    isContinuousValue:false
});

const fetchData = async (productUuid) => {
    try {
        const response = await ApiService.get(`admin/variant_product_reductions/` + productUuid);
        product.value.reductionValue = response.data.data.reductionValue;
        product.value.minPrice = response.data.data.minPrice 
        product.value.maxPrice = response.data.data.maxPrice 
        product.value.productName = response.data.data.productName;
        product.value.isContinuousValue = response.data.data.isContinuousValue;
    } catch(error) {
        swal.error('An error occurred while fetching datas')
    }
}

onMounted(async () => {
    const productUuid = route.params.uuid
    await fetchData(productUuid);
});

function submitHandler(data, formNode) {
    const uuid = route.params.uuid.toString();
    const reductionValue = parseFloat(String(data.reductionValue).replace(',', '.'));
    const minPrice = product.value.isContinuousValue ? parseFloat(String(data.minPrice).replace(',', '.')) :30;
    const maxPrice = product.value.isContinuousValue ? parseFloat(String(data.maxPrice).replace(',', '.')) :30;

    const validatedFields = {};

    return ApiService.patchWithoutSlug("admin/jackpot-variant-product-reductions/" + uuid, {
        reduction_value: reductionValue,
        min_price: minPrice,
        max_price: maxPrice,
    }).then(() => {
        swal.success("Produit modifié !", "");
        router.push({name: 'jackpot'});
    }).catch(({response}) => {
        response.data.errors.forEach((error) => {
            if (!validatedFields[error.property]) {
                formNode.setErrors(null, { [error.property]: error.message });
                validatedFields[error.property] = true;
            }
        });
    });
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, "Gestion des taux du produit " + _toDisplayString(product.value.productName), 1),
    _hoisted_2,
    _hoisted_3,
    _createVNode(CustomButton, {
      to: { name: 'jackpot' },
      label: "Links.goBack"
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FormKit, {
            type: "form",
            onSubmit: submitHandler,
            actions: false,
            model: product.value,
            value: true
          }, {
            default: _withCtx(({ value }) => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FormKit, {
                  type: "text",
                  name: "reductionValue",
                  modelValue: product.value.reductionValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((product.value.reductionValue) = $event)),
                  label: "Taux de réduction*",
                  help: "Si vous insérez 10, cela revient à 10%"
                }, null, 8, ["modelValue"])
              ]),
              (product.value.isContinuousValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "minPrice",
                      modelValue: product.value.minPrice,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((product.value.minPrice) = $event)),
                      label: "Valeur minimale de la carte cadeau*"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "maxPrice",
                      modelValue: product.value.maxPrice,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((product.value.maxPrice) = $event)),
                      label: "Valeur maximale de la carte cadeau*"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_FormKit, {
                  type: "submit",
                  label: "Editer",
                  class: "btn"
                })
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 64))
}
}

})